import { noop } from 'lodash';

import { createContext } from 'use-context-selector';

import { TourOnNextParams, TourStep } from './Tour.types';

interface TourContextProps {
  steps: TourStep[];
  onClose: () => void;
  onNext: (params: TourOnNextParams) => Promise<void>;
}

export const TourContext = createContext<TourContextProps>({
  steps: [],
  onClose: noop,
  onNext: () => Promise.resolve(),
});
